import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { BinaryTheme } from '../../../../Stores/ThemeStore';
import Tooltip from '@cb/solaris-react/Components/Interactive/Tooltip/Tooltip';
import { Size } from '@cb/solaris-react/Constants/System';
import ThemeToggle from '@cb/solaris-react/Components/Utility/ThemeToggle';
import useThemeStore, { useTheme } from '../../../../Hooks/UseThemeStore';
export default function ThemeSwitcher() {
    const themeStore = useThemeStore();
    const { isThemeLoading, themeType } = useTheme();
    if (isThemeLoading) {
        return null;
    }
    return (_jsx(Tooltip, { text: `Click to switch to ${themeType == BinaryTheme.DARK ? 'light' : 'dark'} theme.`, placement: "top", size: Size.small, appendTo: 'parent', children: _jsx("div", { children: _jsx(StyledToggle, { onClick: () => themeStore.toggleTheme() }) }) }));
}
const StyledToggle = styled(ThemeToggle) `
	box-sizing: content-box;
`;
//# sourceMappingURL=ThemeSwitcher.js.map